import React from "react";
import { Link } from "react-router-dom";
import { slugify } from "../../../utils";

const SmartTechCard = ({ projectStyle, portfolio, isHomePage }) => {
  // Function to check if the screen width is for tablet or above
  const isTabletOrAbove = () => {
    return window.innerWidth >= 768; // 768px is a common breakpoint for tablets
  };
  return (
    <>
      <div
        className={`project-grid ${projectStyle}`}
        style={{ border: "1px solid #562b7a" }}
      >
        <div className="thumbnail">
          <Link to={portfolio.link}>
            {/* <img src={process.env.PUBLIC_URL + portfolio.image} alt="icon" /> */}
          </Link>
        </div>
        <div
          className="content"
          style={isTabletOrAbove() ? { minHeight: "500px" } : {}}
        >
          <div style={{ display: "flex" , alignItems:'center'}}>
            <div
              className="icon"
              style={{ paddingRight: "8px", paddingBottom: "10px" }}
            >
              <img src={process.env.PUBLIC_URL + portfolio.icon} alt="Thumb" />
            </div>
            <h4 className="title">
              {portfolio.title}
            </h4>
          </div>

          <span className="subtitle">
            {isHomePage ? (
              <div className="truncated-text">{portfolio.body}</div>
            ) : (
              <>
                <div>{portfolio.paragraph}</div>
                <div style={{ paddingTop: "10px" }}>{portfolio.paragraph2}</div>
              </>
            )}
          </span>
        </div>
      </div>
    </>
  );
};

export default SmartTechCard;
